import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-load-algo-approval',
    templateUrl: './load-algo-approval.component.html',
    styleUrls: ['./load-algo-approval.component.css'],
    standalone: false
})
export class LoadAlgoApprovalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
